import { render } from "./LegalData.vue?vue&type=template&id=7a17be0c"
import script from "./LegalData.vue?vue&type=script&lang=js"
export * from "./LegalData.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__